import { memo } from 'react';
import Avatar from '@material-ui/core/Avatar';
import { BellIcon } from '../../assets/icons';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  className?: string;
}

const NotificationBell = ({ className }: Props) => {
  const classes = useStyles();

  return (
    <Avatar className={[classes.avatar, className].join(' ')}>
      <img src={BellIcon} alt="bell-icon" draggable="false" />
    </Avatar>
  );
}

export default memo(NotificationBell);

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    avatar: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      background: theme.palette.primary.contrastText,
      boxShadow: theme.shadows[1],

      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(8),
        height: theme.spacing(8),
      },

      '&&': {
        '& img': {
          objectFit: 'contain',
          maxHeight: 50,
        }
      }
    },
  })
);